module.exports = __webpack_public_path__ + "static/media/p20.7fd69af9.jpeg";